// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"278":"infobox","522":"Debugger","663":"credits"}[chunkId] || chunkId) + "." + {"22":"3b1583a4","278":"b9407cef","522":"941abe5b","652":"197e6c87","663":"de8773d7"}[chunkId] + ".js";
};